import daCommon from "../locales/da/common.json";
import enCommon from "../locales/en/common.json";
import fiCommon from "../locales/fi/common.json";
import noCommon from "../locales/no/common.json";
import svCommon from "../locales/sv/common.json";
import type { Locale } from "../locales.ts";
import { type AreaCatalog, createTranslator, mergeAreas } from "../translator.ts";

/**
 * The labels `packages/ui` renders on its own.

 * A shadcn component ships its own "Close" and its own breadcrumb landmark, so the shared
 * components need a translator — but only for `common.*`, and they are used by both apps,
 * so neither app's slice would be the right one to reach for.
 */

const catalogs: Readonly<Record<Locale, AreaCatalog>> = {
  sv: mergeAreas([svCommon]),
  no: mergeAreas([noCommon]),
  en: mergeAreas([enCommon]),
  da: mergeAreas([daCommon]),
  fi: mergeAreas([fiCommon]),
};

export const { t, plural } = createTranslator(catalogs);
